import React from 'react';
import { FormattedMessage } from 'react-intl';

import { PhoneNumberInput } from 'src/common/PhoneNumberInput';

import {
  PhoneFieldHintText,
  SignUpPhoneNumberInput,
} from './SignUpFormFieldsPsychFlat.sc';

type PhoneFieldProps = {
  value: any;
  onChange: (value: any) => void;
  onBlur: React.FocusEventHandler<HTMLInputElement>;
  error: any;
  touched: boolean;
  isPhoneNumberMandatoryForSignup: boolean;
};

export const PhoneFormField: React.FC<
  React.PropsWithChildren<PhoneFieldProps>
> = (props: PhoneFieldProps) => {
  return (
    <SignUpPhoneNumberInput>
      <PhoneNumberInput
        value={JSON.parse(props.value)}
        onChange={(value) => props.onChange(JSON.stringify(value))}
        error={props.touched && props.error}
        onBlur={props.onBlur}
      />
      <If condition={!props.touched || !props.error}>
        <PhoneFieldHintText>
          <Choose>
            <When condition={props.isPhoneNumberMandatoryForSignup}>
              <FormattedMessage
                id="signup.mobile.required"
                defaultMessage="Employers require this to reach out to you if you are a good match."
                tagName="span"
              />
            </When>
            <Otherwise>
              <FormattedMessage
                id="signup.mobile.optional"
                defaultMessage="* This is optional but you can include if you'd like us to match you up to suitable jobs faster!"
                tagName="span"
              />
            </Otherwise>
          </Choose>
        </PhoneFieldHintText>
      </If>
    </SignUpPhoneNumberInput>
  );
};
